import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import type { FC } from 'react';
import { useEffect } from 'react';

import { useZustand } from '../../zustandStore';

import { CookieActions } from './cookieActions';
import { CookieIntroduction } from './cookieIntroduction';
import { CookieManagement } from './cookieManagement';

const CookieCutter: FC = () => {
	const { cookies, initializeCookiesFromStorage } = useZustand(state => ({
		cookies: state.cookies,
		initializeCookiesFromStorage: state.initializeCookiesFromStorage,
	}));

	const { open, showManageCookies } = cookies;

	useEffect(() => {
		if (open) {
			initializeCookiesFromStorage();
		}
	}, [open]);

	return (
		<Dialog
			data-testid="cookie-banner"
			open={open}
			onClose={() => false}
			scroll="body"
			sx={{
				zIndex: 2000,
				'.MuiDialog-paper': {
					maxWidth: showManageCookies ? '800px' : '500px',
				},
			}}
		>
			<DialogTitle sx={{ fontWeight: 500 }}>Manage cookie settings</DialogTitle>
			<DialogContent style={{ padding: '0 24px', marginBottom: '20px' }}>
				{showManageCookies ? <CookieManagement /> : <CookieIntroduction />}
			</DialogContent>
			<CookieActions />
		</Dialog>
	);
};

export default CookieCutter;
